<signgaze-listing-item
  [isTrendingswiperActive]="isTrendingActive"
  [screenListing]="screenDetail$ | async"
></signgaze-listing-item>
